import React from "react";
import { OrderListCardSkeleton } from "@/components/list-cards/orders/OrderListCardSkeleton";

interface OrderSkeletonListProps {
  count?: number;
  withAvatar?: boolean;
}

// Simple skeleton items creation - React's key mechanism handles the optimization
const createSkeletonItems = (count: number, withAvatar = true) => {
  return Array.from({ length: count }, (_, index) => (
    <OrderListCardSkeleton
      key={`skeleton-${index}`}
      index={index}
      style={{ height: 'auto' }}
      data={null}
      ref={{ current: null }}
      withAvatar={withAvatar}
    />
  ));
};

// Memoized skeleton lists for common counts
const ThreeOrderSkeletons = React.memo<OrderSkeletonListProps>(({ withAvatar = true }) => (
  <div className="space-y-1" aria-hidden="true">
    {createSkeletonItems(3, withAvatar)}
  </div>
));
ThreeOrderSkeletons.displayName = "ThreeOrderSkeletons";

const FiveOrderSkeletons = React.memo<OrderSkeletonListProps>(({ withAvatar = true }) => (
  <div className="space-y-1" aria-hidden="true">
    {createSkeletonItems(5, withAvatar)}
  </div>
));
FiveOrderSkeletons.displayName = "FiveOrderSkeletons";

export const OrderSkeletonList = React.memo<OrderSkeletonListProps>(({ 
  count = 3,
  withAvatar = true
}) => {
  // Use pre-memoized components for common counts
  if (count === 3) return <ThreeOrderSkeletons withAvatar={withAvatar} />;
  if (count === 5) return <FiveOrderSkeletons withAvatar={withAvatar} />;

  // Fallback for other counts - React's keys handle optimization
  return (
    <div className="space-y-1" aria-hidden="true">
      {createSkeletonItems(count, withAvatar)}
    </div>
  );
});

OrderSkeletonList.displayName = "OrderSkeletonList"; 